import {
  UpdateAlarmGroupStateRequest,
  UpdateAlarmGroupStateResponse,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useUpdateAlarmGroupState(
  alarmGroupId: string,
  onSuccess?: () => void,
  onError?: (err: Error) => void
) {
  const host = window.location.hostname;
  // TODO: update this and use env variables for the base url
  const baseUrl =
    host === 'localhost'
      ? `http://${host}:${window.location.port}`
      : `https://event-flow-${host}`;
  const url = `${baseUrl}/api/alarm_groups/${alarmGroupId}/state`;

  const request = new Request(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return useAuthenticatedMutation<
    UpdateAlarmGroupStateResponse,
    UpdateAlarmGroupStateRequest
  >(request, {
    onSuccessInvalidationKeys: [
      ['alarm_groups'],
      ['alarm_group_details', alarmGroupId],
      ['locationAlarms'],
      ['location_alarm_updates'],
    ],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson;
    },
    onSuccess,
    onError,
  });
}

export default useUpdateAlarmGroupState;
